import React from 'react'

export default function AdminTicketsPage() {
  return (
    <div>
      
    </div>
  )
}
